import React from 'react';
import { Pie } from 'react-chartjs-2';
import { pieDefaults } from '../../utils/chartDefaults';
import { deepMerge, getChartColors, isMissingColor } from '../../utils/chartHelpers';
import type { ChartDataLike } from '../../utils/chartHelpers';
import ChartFrame from './ChartFrame';

const applyPieTheme = (data: ChartDataLike): ChartDataLike => {
    if (!data || !Array.isArray(data.datasets) || data.datasets.length === 0) return data;
    const labelsLength = Array.isArray(data.labels) ? data.labels.length : 0;
    const datasets = data.datasets.map((ds) => {
        const next: any = { ...ds };
        if (isMissingColor(ds.backgroundColor)) {
            next.backgroundColor = getChartColors(Math.max(1, labelsLength));
        }
        return next;
    });
    return { ...data, datasets };
};

export interface PieChartProps {
    data: ChartDataLike;
    options?: any;
    className?: string;
    title?: string;
    badge?: string;
}

const PieChart: React.FC<PieChartProps> = ({ data, options, className, title, badge }) => {
    const merged = React.useMemo(() => deepMerge(pieDefaults, options || {}), [options]);
    const themed = React.useMemo(() => applyPieTheme(data), [data]);
    return (
        <ChartFrame title={title} badge={badge} className={className}>
            <Pie data={themed as any} options={merged} />
        </ChartFrame>
    );
};

export default PieChart;
